<template>
    <div class="cont-vaul-strip">
        <card :class="itemCss" class="wdh-card">
            <div class="head-strip">
                {{ datastrip.type.replace("_", "-") }}
            </div>
            <div class="vault-strip" style="flex-wrap: wrap;">
                <div class="block blok-1 p-0">
                    <!-- <div class="icon">
                        <img :src="itemIcon" :alt="data.real_token_symbol + ' image'" />
                    </div> -->
                    <b-row no-gutters class="strip-name-1 ml-0">
                        <b-col cols="12" class="p-0">
                            <b-row no-gutters class="strip-name-1 ml-0 pt-0">
                                <b-col
                                    cols="6"
                                    md="5"
                                    offset-md="1"
                                    class="head-block"
                                >
                                    <div class="caption-bigger">
                                        {{ this.generateVaultName(datastrip) }}
                                    </div>
                                    <div class="caption">
                                        {{ datastrip.type.replace("_", "-") }}
                                    </div>
                                    <div class="caption">
                                        {{ datastrip.time_period }}
                                    </div>
                                </b-col>
                                <b-col
                                    cols="6"
                                    md="6"
                                    class="head-block pl-0 icon-coin-container right-text-mobile"
                                >
                                    <img
                                        :src="itemIcon"
                                        alt="coin vault strip"
                                    />
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="8" md="11" offset-md="1" class="pr-0 pl-1">
                            <div class="percentage" id="apy-percentage">
                                {{
                                    datastrip.apy < 0
                                        ? `${moneyFormat(datastrip.apy)}`
                                        : `+${moneyFormat(datastrip.apy)}`
                                }}%
                            </div>
                            <div class="percentage-description">
                                Current Projected Yield (APY)
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="block b-left b-right blok-2">
                    <div class="row" style="position:relative;">
                        <div
                            class="mbo-3"
                            style="height: 0.625vw;display: block;width: 1px;"
                        ></div>
                        <div class="col-12 mbo-3">
                            <div class="row">
                                <div class="col-6 text-uppercase">contract</div>
                                <div class="col-6 text-right font-weight-bold">
                                    <a
                                        id="contract-address-withdraw"
                                        class="text-green-gradient"
                                        target="_blank"
                                        :title="data.contract_address"
                                        :href="
                                            `${getTokenUrl(
                                                data.network
                                            )}/address/${data.contract_address}`
                                        "
                                        >{{ getContract }}</a
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mbo-3">
                            <div class="row">
                                <div class="col-6">
                                    <label class="text-capitalize"
                                        >YOUR DEPOSITS</label
                                    >
                                </div>
                                <div class="col-6 text-right d-lg-none">
                                    <label class="text-capitalize"
                                        >YOUR BALANCE</label
                                    >
                                </div>
                            </div>
                            <div class="row font-weight-bold">
                                <div class="col-6">
                                    <div v-if="this.walletProvider">
                                        <span class="text-lg-1" id="deposit">
                                            {{ calcTokenBalance }}
                                        </span>
                                        <span
                                            style="text-transform:uppercase;"
                                            class="text-lg-2"
                                            id="token"
                                        >
                                            {{ data.real_token_symbol }}
                                        </span>
                                    </div>
                                    <span class="text-lg-1" v-else>-</span>
                                </div>
                                <div class="col-6 text-right d-lg-none">
                                    <span
                                        class="text-lg-1"
                                        v-if="premiumLoad"
                                        id="balance"
                                        >{{
                                            moneyFormat(calcYourPosition)
                                        }}</span
                                    >
                                    <span class="text-lg-1" v-else>-</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mbo-3">
                            <label class="text-capitalize"
                                >PREMIUM REALIZED</label
                            >
                            <div class="font-weight-bold">
                                <div class="row">
                                    <div class="col-6">
                                        <div v-if="premiumLoad">
                                            <span
                                                class="text-lg-1"
                                                id="premium-realized"
                                                >{{ calcPremiumRealize }}</span
                                            >
                                            <span
                                                class="text-lg-2"
                                                style="text-transform:uppercase;"
                                            >
                                                {{
                                                    data.real_token_symbol
                                                }}</span
                                            >
                                        </div>
                                        <span class="text-lg-1" v-else>-</span>
                                    </div>
                                    <div class="col-6 text-right">
                                        <span
                                            class="text-lg-1"
                                            v-if="premiumLoad"
                                            id="premium"
                                            >{{ formatCurrency(calcPremium) }}
                                        </span>
                                        <span class="text-lg-1" v-else>-</span>
                                        <span class="text-lg-2"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-6 col-md-12 mbo-3 mob-balance mobile-hidden"
                        >
                            <label class="text-capitalize">TOTAL BALANCE</label>
                            <div class="font-weight-bold d-flex" style="justify-content: space-between; flex-direction: column;">
                                <span
                                    class="text-lg-1"
                                    v-if="premiumLoad"
                                    id="balance2"
                                    >
                                    {{ moneyFormat(userInfo.totalBalance,6) }}
                                    <span class="text-lg-2" style="text-transform:uppercase;">{{ data.real_token_symbol }}</span>
                                </span>
                                <span class="text-lg-1" v-else>-</span>
                                <span
                                    class="text-lg-1"
                                    v-if="premiumLoad"
                                    id="balance"
                                    >
                                    {{formatCurrency(calcYourPosition)}}
                                </span>
                                <span class="text-lg-1" v-else>-</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block b-left blok-3">
                    <div class="tab mbo-3">
                        <div
                            class="tab-item"
                            :class="{ active: tabState === 'DEPOSIT' }"
                            @click="tabSelected('DEPOSIT')"
                        >
                            Deposit
                        </div>
                        <div
                            class="tab-item"
                            :class="{ active: tabState === 'WITHDRAW' }"
                            @click="tabSelected('WITHDRAW')"
                        >
                            Withdraw
                        </div>
                        <div
                            v-if="data.can_wrap"
                            class="tab-item"
                            :class="{ active: tabState === 'WRAP' }"
                            @click="tabSelected('WRAP')"
                        >
                            Wrap
                        </div>
                    </div>
                    <div v-if="tabState === 'DEPOSIT'" class="mob-space">
                        <div class="row pxo-3 mbo-3 d-none">
                            <div class="col-6 text-uppercase">contract</div>
                            <div class="col-6 text-right font-weight-bold">
                                <a
                                    id="contract-address"
                                    class="text-green-gradient"
                                    target="_blank"
                                    :title="data.contract_address"
                                    :href="
                                        `${getTokenUrl(data.network)}/address/${
                                            data.contract_address
                                        }`
                                    "
                                    >{{ getContract }}</a
                                >
                            </div>
                        </div>
                        <div class="row pxo-3 mbo-3">
                            <div class="col-6 text-uppercase">
                                Depositing Ends in
                            </div>
                            <div class="col-6 text-right font-weight-bold">
                                <count-down
                                    v-if="datastrip"
                                    :expiry="datastrip.vault_detail.expiry"
                                    id="expiry"
                                    vault="datastrip"
                                />
                            </div>
                        </div>
                        <div class="row pxo-3 mbo-3">
                            <div class="col-6 text-uppercase">
                                Available Balance
                            </div>
                            <div class="col-6 text-right font-weight-bold">
                                <span style="text-transform:uppercase;">
                                    {{ wallet.balance }}
                                    {{ data.real_token_symbol }}
                                </span>
                            </div>
                        </div>
                        <div>
                            <div
                                class="input-group input-group-outline mbo-3 flex-nowrap"
                            >
                                <input
                                    type="number"
                                    class="form-control mto-1"
                                    :placeholder="
                                        `0 ${data.real_token_symbol.toUpperCase()}`
                                    "
                                    aria-label="Deposits"
                                    aria-describedby="basic-addon2"
                                    :disabled="!approved || depositing"
                                    v-model="depositInput"
                                    id="deposit-input"
                                    @keypress="isNumber($event)"
                                />
                                <div class="input-group-append text-center">
                                    <a
                                        id="deposit-max"
                                        :class="
                                            !approved || depositing
                                                ? 'disabled'
                                                : ''
                                        "
                                        @click="maxDeposit"
                                        class="text-green-gradient max-button-style"
                                        href="#"
                                        >MAX</a
                                    >
                                </div>
                            </div>
                        </div>

                        <div class="row pxo-3 mbo-3">
                            <!--mb-n4 -->
                            <template v-if="approved && hasToken">
                                <template v-if="!depositing">
                                    <div
                                        v-if="hasQueuedWithdrawls"
                                        style="display: flex;justify-content: center;width: 100%;padding-bottom: 1em;"
                                    >
                                        Can't deposit while withdrawals are
                                        pending
                                    </div>
                                    <div class="col-6 d-flex">
                                        <button
                                            @click="depositToVault"
                                            class="btn btn-primary btn-vault-strip"
                                            type="button"
                                            :disabled="depositDisabled"
                                            id="deposit-more"
                                        >
                                            deposit
                                        </button>
                                    </div>
                                    <div
                                        class="col-6 d-flex justify-content-end"
                                    >
                                        <button
                                            class="btn btn-secondary btn-vault-strip"
                                            type="button"
                                            @click="cancelDeposit"
                                            :disabled="
                                                userInfo.exitQueueEpoch != 0 ||
                                                    userInfo.queuedDeposits ==
                                                        0 ||
                                                    depositing ||
                                                    pQueuedDeposits == 0
                                            "
                                            id="cancel-deposit"
                                        >
                                            cancel
                                        </button>
                                    </div>
                                </template>
                                <div
                                    v-else
                                    style="display: flex;align-items: center;margin-left: 2em;width: 100%;justify-content: center; height:20px;"
                                >
                                    <div
                                        class="text-green-gradient"
                                        id="waiting-for-reply"
                                    >
                                        Waiting for reply
                                    </div>
                                    <div>&nbsp;</div>
                                    <div
                                        style="display: flex;min-width:4em;justify-content: center;align-items: center;position: relative;padding: 2rem 0;overflow: hidden;"
                                    >
                                        <div class="dot-falling"></div>
                                    </div>
                                </div>
                            </template>

                            <div v-else class="col-12">
                                <div
                                    v-if="!hasWallet"
                                    style="text-align:center"
                                >
                                    Connect Metamask / Wallet Connect
                                </div>
                                <template v-else>
                                    <template v-if="!hasToken">
                                        <div
                                            v-if="checkingToken"
                                            style="display:flex;flex-direction: row;justify-content: center;align-items: center; height:20px"
                                        >
                                            <div
                                                class="text-green-gradient"
                                                id="checking-token-approval"
                                            >
                                                Checking
                                                {{ data.token }} approval
                                            </div>
                                            <div>&nbsp;</div>
                                            <div
                                                style="display: flex;min-width:4em;justify-content: center;align-items: center;position: relative;padding: 2rem 0;overflow: hidden;"
                                            >
                                                <div class="dot-falling"></div>
                                            </div>
                                        </div>
                                        <button
                                            v-else
                                            class="btn btn-primary  btn-vault-strip"
                                            style="width:100%;"
                                            @click="addToken(data.token)"
                                            id="add-to-wallet"
                                        >
                                            Add {{ data.token }} to wallet
                                        </button>
                                    </template>

                                    <template v-else>
                                        <div
                                            v-if="checkingApproval"
                                            style="display:flex;flex-direction: row;justify-content: center;align-items: center; height:20px"
                                        >
                                            <div
                                                class="text-green-gradient"
                                                id="checking-asset-approval"
                                            >
                                                Checking asset approval
                                            </div>
                                            <div>&nbsp;</div>
                                            <div
                                                style="display: flex;min-width:4em;justify-content: center;align-items: center;position: relative;padding: 2rem 0;overflow: hidden;"
                                            >
                                                <div class="dot-falling"></div>
                                            </div>
                                        </div>
                                        <button
                                            v-else
                                            class="btn btn-primary btn-vault-strip"
                                            style="width:100% !important;"
                                            @click="approve"
                                            id="approve-vault-allowance"
                                        >
                                            Approve vault allowance
                                        </button>
                                    </template>
                                </template>
                            </div>
                        </div>

                        <div class="row pxo-3 mbo-1">
                            <div class="col-6 text-uppercase pl-0">
                                deposit pending
                            </div>
                            <div
                                class="col-6 text-right font-weight-bold"
                                style="text-transform:uppercase"
                            >
                                <div v-if="pQueuedDeposits">
                                    <span id="deposit-pending">
                                        {{ pQueuedDeposits }}
                                    </span>
                                    {{ data.real_token_symbol }}
                                </div>
                                <span class="text-lg-1" v-else>-</span>
                            </div>
                        </div>
                        <!-- <div class="row pxo-3 mbo-4">
                            <div class="col-6 text-uppercase">
                                transaction type
                            </div>
                            <div class="col-6 text-right font-weight-bold">
                                Deposit
                            </div>
                        </div> -->
                    </div>
                    <div v-if="tabState === 'WITHDRAW'" class="mob-space">
                        <div class="row pxo-3 mbo-3 d-none">
                            <div class="col-6 text-uppercase">contract</div>
                            <div class="col-6 text-right font-weight-bold">
                                <a
                                    id="contract-address-withdraw"
                                    class="text-green-gradient"
                                    target="_blank"
                                    :title="data.contract_address"
                                    :href="
                                        `${getTokenUrl(data.network)}/address/${
                                            data.contract_address
                                        }`
                                    "
                                    >{{ getContract }}</a
                                >
                            </div>
                        </div>
                        <div class="row pxo-3 mbo-3">
                            <div
                                class="col-6 text-uppercase d-flex align-items-center"
                            >
                                <span class="tooltip-selector">
                                    Request Withdraw
                                    <img
                                        class="tooltip-icon"
                                        src="/images/icon-info-green.svg"
                                        alt="ingfo"
                                    />
                                    <div class="tooltip-container">
                                        <div class="tooltip-bg-blur">
                                            <ul>
                                                <li class="mb-1">
                                                    Make a withdrawal if you
                                                    have pending withdrawals
                                                </li>
                                                <li class="mb-1">
                                                    Withdrawals can only be
                                                    executed after settlement of
                                                    the current epoch
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <!-- <div class="row pxo-3 mbo-1">
                            <div class="col-6 text-uppercase">
                                transaction type
                            </div>
                            <div class="col-6 text-right font-weight-bold">
                                Withdraw
                            </div>
                        </div> -->

                        <div style="display:flex;" class="mbo-3">
                            <div
                                class="input-group input-group-outline mbo-3___ flex-nowrap"
                                style="/* margin-left:1em */"
                            >
                                <input
                                    type="number"
                                    class="form-control mto-1"
                                    :placeholder="
                                        `0 ${data.real_token_symbol.toUpperCase()}`
                                    "
                                    aria-label="Withdrawl"
                                    aria-describedby="basic-addon2"
                                    v-model="withdrawlInput"
                                    :disabled="canInitWithdraw"
                                    id="withdraw-input"
                                    @keypress="isNumber($event)"
                                />
                                <div class="input-group-append text-center">
                                    <a
                                        id="max-withdraw"
                                        :class="
                                            canInitWithdraw ? 'disabled' : ''
                                        "
                                        @click="getMaxWithdrawal"
                                        class="text-green-gradient max-button-style"
                                        href="#"
                                        >MAX</a
                                    >
                                </div>
                            </div>
                            <div class="input-group-prepend ml-1">
                                <button
                                    v-if="!requesting"
                                    class="btn p-0 btn-sm btn-primary text-center btn-withdraw-request"
                                    type="button"
                                    style="width: 100%;font-size: 80%;padding: 0px 12px !important;height: 88%;margin-top:3%;"
                                    :disabled="
                                        canInitWithdraw ||
                                            withdrawlInput == '' ||
                                            withdrawlInput <= 0
                                    "
                                    @click="initWithdraw"
                                    id="init-withdraw"
                                >
                                    Request
                                </button>
                                <div v-else>
                                    <div class="stageX">
                                        <div class="dot-falling"></div>
                                    </div>

                                    <!-- <div style="display: flex;min-width:4em;justify-content: center;align-items: center;position: relative;padding: 1.4vh 0;overflow: hidden;"><div class="dot-falling2"></div></div> -->
                                </div>
                            </div>
                        </div>
                        <div class="row pxo-3 mbo-3">
                            <div
                                class="col-12 text-uppercase d-flex align-items-center"
                                style="border-top: 1px solid rgba(255,255,255, 0.5); padding-top: 10px;"
                            >
                                <span class="tooltip-selector">
                                    Withdraw
                                    <img
                                        class="tooltip-icon"
                                        src="/images/icon-info-green.svg"
                                        alt="ingfo"
                                    />
                                    <div class="tooltip-container">
                                        <div class="tooltip-bg-blur">
                                            <ul>
                                                <li class="mb-1">
                                                    Make a withdrawal if you
                                                    have pending withdrawals
                                                </li>
                                                <li class="mb-1">
                                                    Withdrawals can only be
                                                    executed after settlement of
                                                    the current epoch
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div class="row pxo-3 mbo-3">
                            <div class="col-6 text-uppercase">
                                pending withdrawals
                            </div>
                            <div
                                class="col-6 text-right font-weight-bold"
                                style="text-transform:uppercase"
                            >
                                <span id="withdraw-pending">
                                    {{ pendingWithdrawal }}
                                </span>
                                <!--{{ ( (+this.data.exitQueueEpoch==0)?0:this.data.queuedWithdraw) }}-->
                                {{ data.real_token_symbol.toUpperCase() }}
                            </div>
                        </div>
                        <div class="row pxo-3 mbo-3">
                            <template v-if="canWithdraw">
                                <div
                                    class="col-12 text-uppercase"
                                    style="text-align: center;"
                                >
                                    Settled, ready for withdrawal
                                </div>
                            </template>
                            <template v-else-if="isExpired">
                                <div
                                    class="col-12 text-uppercase"
                                    style="text-align: center;"
                                >
                                    withdrawal ready after settlement
                                </div>
                            </template>
                            <template v-else>
                                <div class="col-6 text-uppercase">
                                    processing starts in
                                </div>
                                <div class="col-6 text-right font-weight-bold">
                                    <count-down
                                        v-if="datastrip"
                                        :expiry="datastrip.vault_detail.expiry"
                                        :vault="datastrip"
                                        id="expiry-withdraw"
                                    />
                                    <!--{{ getExpiry }}-->
                                </div>
                            </template>
                        </div>
                        <div class="row">
                            <!--mb-n4 -->
                            <div class="col-6 d-flex">
                                <button
                                    class="btn btn-secondary btn-vault-strip"
                                    type="button"
                                    @click="cancelWithdraw"
                                    :disabled="canCancelWithdraw || canWithdraw"
                                    id="cancel-withdraw"
                                >
                                    cancel
                                </button>
                            </div>
                            <div class="col-6 d-flex justify-content-end">
                                <button
                                    v-if="!withdrawing"
                                    class="btn btn-primary btn-vault-strip"
                                    type="button"
                                    :disabled="!canWithdraw"
                                    @click="doWithdraw"
                                    id="do-withdraw"
                                >
                                    withdraw
                                </button>
                                <div
                                    v-else
                                    style="display: flex;align-items: center;margin-left: 2em;"
                                >
                                    <div class="text-green-gradient">
                                        Withdrawing
                                    </div>
                                    <div>&nbsp;</div>
                                    <div
                                        style="display: flex;min-width:4em;justify-content: center;align-items: center;position: relative;padding: 2rem 0;overflow: hidden;"
                                    >
                                        <div class="dot-falling"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <VaultWrap
                        v-if="tabState === 'WRAP'"
                        class="mob-space"
                        :vault="data"
                    />
                </div>
            </div>
        </card>
    </div>
</template>

<script>
//import Vue from "vue";

import Card from "./Card";
import VaultWrap from "./VaultWrap.vue";

import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";
import Decimal from "decimal.js";
export default {
    name: "VaultStrip",
    components: {
        Card,
        VaultWrap
    },
    data() {
        return {
            pCounter: 0,
            tabState: this.tab,
            datastrip: this.data,
            depositInput: "",
            wrapInputFrom: "",
            wrapInputTo: "",
            myTotalDeposits: "",
            withdrawlInput: null,
            approved: false,
            hasToken: true, //
            checkingApproval: true,
            checkingToken: false, //,
            ableToInitWithdraw: false,
            depositing: false,
            assetScaleX1e36: 0,
            userScaleX1e36: 0,
            activeDeposit: 0,
            requesting: false,
            premiumLoad: false,
            updateInterval: null,
            withdrawing: false,
            vaultAtMaxBalance: false,
            window: window,
            allowInteraction: null
        };
    },
    watch: {
        pQueuedDeposits(newValue, oldValue) {
            //
        },
        pQueuedWithdraws(newValue, oldValue) {
            //
        },
        "$store.state.wallet.balance": {
            handler: function(nval) {
                //
                this.checkingToken = false;
                if (nval > 0) {
                    this.hasToken = true;
                } else {
                    //this.checkingToken = false;
                }
            }
            //this.depositInput = this.wallet.balance;
        },

        // '$store.state.vaults.contract': function(nval)  {
        //     //
        //     //this.myDeposits();

        //     //this.getInfo();
        // },
        address(nv, ov) {
            this.$emit("update-vault");
            this.approved = false;
            this.checkingApproval = true;
            this.depositInput = "";
            this.withdrawlInput = "";
            this.checkAllowance();
            this.premiumLoad = nv ? true : false;
        },
        userInfo: {
            handler: function(nVal, oVal) {
                //
            },
            deep: true
        },
        withdrawlInput(v,o){
            const splitValue = v.split('.');
            const token = this.wallet.tokens.find(item => item.symbol == this.data.real_token_symbol && item.network == this.data.network);

            const decimalPlaces = (splitValue[1]).length; // count decimal places
            if(decimalPlaces > token.decimals.toString().length - 1) this.withdrawlInput = o // compare inputed amount decimal with token decimal
        },
        depositInput(v,o){
            const splitValue = v.split('.');
            const token = this.wallet.tokens.find(item => item.symbol == this.data.real_token_symbol && item.network == this.data.network);

            const decimalPlaces = (splitValue[1]).length; // count decimal places
            if(decimalPlaces > token.decimals.toString().length - 1) this.depositInput = o // compare inputed amount decimal with token decimal
        }
    },
    computed: {
        ...mapState(["vaults", "wallet"]),
        ...mapGetters({
            hasWallet: "wallet/getHasWallet",
            address: "wallet/getAddress",
            walletProvider: "wallet/getWalletProvider",
        }),
        pendingWithdrawal(){
            return +this.userInfo.pendingWithdrawal;
        },
        tokenText() {
            if (this.wallet.tokenText)
                return this.wallet.tokenText.toUpperCase();
            else return;
        },
        getContract() {
            let str = this.data.contract_address;
            return (
                str.substring(0, 10) +
                "..." +
                str.substring(str.length - 4, str.length)
            );
        },
        hasQueuedWithdrawls() {
            return (
                this.userInfo.queuedWithdraw > 0 &&
                this.userInfo.exitQueueEpoch > 0
            );
        },
        depositDisabled() {
            return (
                this.vaultAtMaxBalance ||
                this.depositInput === "" ||
                this.depositInput <= 0 ||
                +this.depositInput > +this.wallet.balance ||
                (this.userInfo.queuedWithdraw > 0 &&
                    this.userInfo.exitQueueEpoch > 0)
            );
        },
        calcPremiumRealize() {
            return this.moneyFormat(this.userInfo.premiumRealised,6);
            // let token = this.wallet.tokens.find(
            //     item =>
            //         item.symbol == this.data.real_token_symbol &&
            //         item.network == this.data.network
            // );
            return Decimal(this.userInfo.maxWithdraw).minus(this.userInfo.activeDeposit).toFixed(6);

            // let premiumRealized = Decimal("0");
            // if (
            //     token &&
            //     this.data.vault_detail.expiry_timestamp &&
            //     this.userInfo.activeDeposit &&
            //     this.data.total_asset &&
            //     this.data.premiums_paid
            // ) {
            //     const expiryTimestamp = this.data.vault_detail.expiry_timestamp;
            //     const currentEpochDeposit = Decimal(
            //         this.userInfo.activeDeposit
            //     );
            //     const totalAsset = Decimal(this.data.total_asset);
            //     const premiumsPaid = Decimal(this.data.premiums_paid);

            //     if (expiryTimestamp > 0) {
            //         if (totalAsset.toString() !== "0") {
            //             premiumRealized = currentEpochDeposit
            //                 .dividedBy(totalAsset)
            //                 .times(premiumsPaid)
            //         }
            //     } else if (expiryTimestamp === 0) {
            //         const newTotalAsset = totalAsset.plus(premiumsPaid);
            //         if (newTotalAsset.toString() !== "0") {
            //             premiumRealized = currentEpochDeposit
            //                 .dividedBy(newTotalAsset)
            //                 .times(premiumsPaid)
            //         }
            //     }
            // }

            // return premiumRealized.toFixed(6);
        },
        calcPremium() {
            const conversion =
                this.data.type == "put_selling" ? 1 : this.data.usd_price;
            return (+this.calcPremiumRealize * conversion).toFixed(2);
        },
        calcTokenBalance() {
            if (!this.walletProvider) return 0;
            const decimal = this.data.type == "put_selling" ? 2 : 6;

            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.data.real_token_symbol &&
                    item.network == this.data.network
            );

            // const tokenBalance = this.userInfo.deposit / token.decimals;
            const tokenBalance = this.userInfo.activeDeposit;

            if (tokenBalance != 0)
                return this.moneyFormat(tokenBalance, decimal);
            else return this.moneyFormat(tokenBalance);
        },
        calcWalletBalance() {
            if (!this.walletProvider) return 0;
            const decimal = this.data.type == "put_selling" ? 2 : 6;

            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.data.real_token_symbol &&
                    item.network == this.data.network
            );

            const tokenBalance = this.wallet.baseBalance / token.decimals;

            if (tokenBalance != 0)
                return this.moneyFormat(tokenBalance, decimal);
            else return this.moneyFormat(tokenBalance);
        },
        calcBalance() {
            let extra = 0,
                adjustmentFactor = 1;
            if (this.userInfo.queuedEpoch >= this.data.epoch)
                extra = this.userInfo.queuedDeposits;
            if (this.userInfo.userScaleX1e36 != 0)
                adjustmentFactor =
                    this.data.assetScaleX1e36 / this.userInfo.userScaleX1e36;
            return (this.userInfo.activeDeposit + extra) * adjustmentFactor;
        },
        calcYourPosition() {
            const conversion = this.data.type == "put_selling" ? 1 : this.data.usd_price;

            // let token = this.wallet.tokens.find(
            //     item =>
            //         item.symbol == this.data.real_token_symbol &&
            //         item.network == this.data.network
            // );

            return (+this.userInfo.totalBalance) * conversion;
        },
        canInitWithdraw() {
            return !this.ableToInitWithdraw;
        },
        canWithdraw() {
            //
            if (this.userInfo.exitQueueEpoch == 0) return false;
            if (
                (this.data.epoch == +this.userInfo.exitQueueEpoch - 1 &&
                    this.data.expiry == 0) ||
                this.data.epoch >= +this.userInfo.exitQueueEpoch
            ) {
                //
                return true;
            } else {
                //
                return false;
            }
            //return +this.data.queuedWithdraw > 0 && +this.data.exitQueueEpoch > 0
        },
        canCancelWithdraw() {
            return !(
                +this.userInfo.exitQueueEpoch > 0 &&
                +this.userInfo.queuedWithdraw > 0
            );
        },
        getDepositPending() {
            //queuedEpoch
            if (+this.data.epoch >= this.userInfo.queuedEpoch) {
                return 0;
            } else {
                return this.userInfo.queuedDeposits;
            }
        },
        getStrike() {
            if (this.data.strike_price == null) return "---";
            return +this.data.strike_price;
        },
        isExpired() {
            //
            if (this.data.time_on_expiry == null) return false;
            return moment
                .utc(+(this.data.time_on_expiry + "000"))
                .isBefore(moment.utc());
        },
        getExpiry() {
            if (this.data.time_on_expiry == null) return "---";
            let mex = moment
                .utc(+(this.data.time_on_expiry + "000"))
                .diff(moment());
            if (mex <= 0) return "---";
            //mex = 1000000
            //
            let timeDiff = moment
                .utc(moment.duration(mex, "seconds").asMilliseconds())
                .format("HH[h]:mm[m]:ss[s]");
            //
            return timeDiff; //moment.utc(+(this.data.time_on_expiry + '000')).diff(moment());
        },
        itemCss() {
            return `${this.data.color}-card`;
        },
        itemIcon() {
            // return `/icon/${this.data.nut}.png`;
            return `/images/crypto-icons/icon-coin-${this.data.token}.svg`;
        },
        calcMaxWithdrawal() {
            return this.userInfo.maxWithdraw;
            const maxWithdrawal = this.userInfo.maxWithdraw !== undefined ? +this.userInfo.maxWithdraw + +this.userInfo.premiumRealised : 0;

            return maxWithdrawal;
        }
    },
    methods: {
        Decimal,
        moment,
        tabSelected(tabSelected) {
            this.tabState = tabSelected;
            localStorage.tabState = tabSelected;
        },
        formatCurrency(val) {
            const formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            return formatter.format(val);
        },
        ...mapActions(["vaults.deposit", "vaults.approve"]),
        async addToken(wwe) {
            this.checkingToken = true;

            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.data.real_token_symbol &&
                    item.network == this.data.network
            );
            //
            if (token == undefined) return;
            let res = await this.$store.dispatch("wallet/addToken", {
                vault_contract: this.data.contract_address,
                token: token
            });

            if (res) {
                this.hasToken = true;
                this.checkingToken = false;
                this.checkAllowance();
            } else {
                this.hasToken = false;
                this.checkingToken = false;
            }
        },
        async initRound() {
            await this.$store.dispatch(
                "vaults/initRound",
                this.data.contract_address
            );
        },
        async cancelDeposit() {
            this.depositing = true;

            let cancelRes;
            let payload = {
                vault_contract: this.data.contract_address,
                abiType: this.data.type
            };

            try {
                if(this.walletProvider == "walletconnect") {
                    this.$store.dispatch("vaults/cancelDeposit", payload)
                    .then((response) => {
                        console.log("Confirmed Block Number: ", response);
                        if (response) {
                            this.depositing = false;
                            this.depositInput = "";
                            this.$nextTick(() => {
                                this.$emit("update-vault");
                            });
                        }
                    })
                    .catch((error) => {
                        Vue.default.toasted.error(error.message, { duration: 3000});
                        this.depositing = false;
                    });
                    return;
                } else {
                    cancelRes = await this.$store.dispatch(
                        "vaults/cancelDeposit",
                        payload
                    );
                }
            } catch (error) {
                // if user using brave wallet & reject the request
                if ((navigator.brave && await navigator.brave.isBrave() || false) && error.code === -32602 && error.message == "User rejected the transaction") {
                    Vue.default.toasted.error("User rejected the request");
                    this.depositing = false;
                    return;
                }

                if (error.code && error.code === -32602) {
                    // send request in non EIP-1559 format
                    payload.type = "0x0";
                    cancelRes = await this.$store.dispatch(
                        "vaults/cancelDeposit",
                        payload
                    );
                }
            }

            this.$emit("update-vault");
            this.depositing = false;
            this.depositInput = "";
        },
        async cancelWithdraw() {
            let cancelW;
            let payload = {
                vault_contract: this.data.contract_address,
                abiType: this.data.type
            };

            try {
                if(this.walletProvider == "walletconnect") {
                    this.$store.dispatch("vaults/cancelWithdraw", payload)
                    .then((response) => {
                        console.log('Confirmed Block Number: ', response);
                        if (response) {
                            this.withdrawlInput = "";
                            this.$nextTick(() => {
                                this.$emit("update-vault");
                            });
                        }
                    })
                    .catch((error) => {
                        Vue.default.toasted.error(error.message, { duration: 3000});
                    });
                    return;
                } else {
                    cancelW = await this.$store.dispatch(
                        "vaults/cancelWithdraw",
                        payload
                    );
                }
            } catch (error) {
                // if user using brave wallet & reject the request
                if ((navigator.brave && await navigator.brave.isBrave() || false) && error.code === -32602 && error.message == "User rejected the transaction") {
                    Vue.default.toasted.error("User rejected the request");
                    return;
                }

                if (error.code && error.code === -32602) {
                    // send request in non EIP-1559 format
                    payload.type = "0x0";
                    cancelW = await this.$store.dispatch(
                        "vaults/cancelWithdraw",
                        payload
                    );
                }
            }

            this.$emit("update-vault");

            this.withdrawlInput = "";
        },
        async doWithdraw() {
            this.withdrawing = true;

            let withdrawRes;
            let payload = {
                vault_contract: this.data.contract_address,
                abiType: this.data.type
            };

            try {
                if(this.walletProvider == "walletconnect") {
                    this.$store.dispatch("vaults/doWithdraw", payload)
                    .then((response) => {
                        console.log('Confirmed Block Number: ', response);
                        if (response) {
                            this.withdrawing = false;
                            this.$nextTick(() => {
                                this.$emit("update-vault");
                            });
                        }
                    })
                    .catch((error) => {
                        Vue.default.toasted.error(error.message, { duration: 3000});
                        this.withdrawing = false;
                    });
                    return;
                } else {
                    withdrawRes = await this.$store.dispatch(
                        "vaults/doWithdraw",
                        payload
                    );
                }
            } catch (error) {
                // if user using brave wallet & reject the request
                if ((navigator.brave && await navigator.brave.isBrave() || false) && error.code === -32602 && error.message == "User rejected the transaction") {
                    Vue.default.toasted.error("User rejected the request");
                    this.withdrawing = false
                    return;
                }

                if (error.code && error.code === -32602) {
                    // send request in non EIP-1559 format
                    payload.type = "0x0";
                    withdrawRes = await this.$store.dispatch(
                        "vaults/doWithdraw",
                        payload
                    );
                }
            }

            this.withdrawing = false;

            this.$emit("update-vault");
        },
        async initWithdraw() {
            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.data.real_token_symbol &&
                    item.network == this.data.network
            );
            if (token == undefined) return;

            this.requesting = true;
            this.checkingApproval = true;

            let withdrawRes;
            let payload = {
                vault_contract: this.data.contract_address,
                amount: this.withdrawlInput,
                abiType: this.data.type,
                maxWithdraw: this.calcMaxWithdrawal,
                token: token,
                queuedDeposits: this.pQueuedDeposits
            };

            try {
                if(this.walletProvider == "walletconnect") {
                    this.$store.dispatch("vaults/initWithdraw", payload)
                    .then((response) => {
                        console.log('Confirmed Block Number: ', response);
                        if (response) {
                            this.withdrawlInput = "";
                            this.requesting = false;
                            this.checkingApproval = false;
                            this.$nextTick(() => {
                                this.$emit("update-vault");
                            });
                        }
                    })
                    .catch((error) => {
                        Vue.default.toasted.error(error.message, { duration: 3000});
                        this.requesting = false;
                        this.checkingApproval = false;
                    });
                    return;
                } else {
                    withdrawRes = await this.$store.dispatch(
                        "vaults/initWithdraw",
                        payload
                    );
                }
            } catch (error) {
                // if user using brave wallet & reject the request
                if ((navigator.brave && await navigator.brave.isBrave() || false) && error.code === -32602 && error.message == "User rejected the transaction") {
                    Vue.default.toasted.error("User rejected the request");
                    this.requesting = false
                    this.checkingApproval = false
                    return;
                }

                if (error.code && error.code === -32602) {
                    // send request in non EIP-1559 format
                    payload.type = "0x0";
                    withdrawRes = await this.$store.dispatch(
                        "vaults/initWithdraw",
                        payload
                    );
                }
            }

            this.$emit("update-vault");

            this.withdrawlInput = "";
            this.requesting = false;
            this.checkingApproval = false;
        },
        async depositToVault() {
            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.data.real_token_symbol &&
                    item.network == this.data.network
            );
            if (token == undefined) return;

            this.depositing = true;

            let deposit;
            let payload = {
                amount: this.depositInput,
                vault_contract: this.data.contract_address,
                abiType: this.data.type,
                maxDeposit: this.data.max_deposit, //this value is overwritten by the max deposit value from the vault contract via getVaultInfo() instead of db
                token: token
            };

            try {
                if(this.walletProvider == "walletconnect") {
                    this.$store.dispatch("vaults/deposit", payload)
                    .then((response) => {
                        console.log('Confirmed Block Number: ', response);
                        if (response) {
                            this.depositInput = "";
                            this.depositing = false;
                            this.$nextTick(() => {
                                this.$emit("update-vault");
                            });
                        }
                    })
                    .catch((error) => {
                        Vue.default.toasted.error(error.message, { duration: 3000});
                        this.depositing = false;
                    });
                    return;
                } else {
                    deposit = await this.$store.dispatch("vaults/deposit", payload);
                }
            } catch (error) {
                // if user using brave wallet & reject the request
                if ((navigator.brave && await navigator.brave.isBrave() || false) && error.code === -32602 && error.message == "User rejected the transaction") {
                    Vue.default.toasted.error("User rejected the request");
                    this.depositing = false
                    return;
                }

                if (error.code && error.code === -32602) {
                    // send request in non EIP-1559 format
                    payload.type = "0x0";
                    deposit = await this.$store.dispatch(
                        "vaults/deposit",
                        payload
                    );
                }
            }

            this.$emit("update-vault");
            this.depositInput = "";
            this.depositing = false;
        },
        //async getInfo(){
        //     let res = await this.$store.dispatch('vaults/getInfo', this.data.contract_address);
        //     //

        // },
        // async myDeposits(){
        //     let res = await this.$store.dispatch('vaults/myDeposits', {
        //         vault_contract: this.data.contract_address,
        //         abiType: this.data.type
        //     });

        //     this.myTotalDeposits = res;
        //     //

        // },
        async checkAllowance() {
            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.data.real_token_symbol &&
                    item.network == this.data.network
            );
            if (token == undefined) return;

            this.$store.commit("wallet/setSelectedToken", {
                token: this.data.real_token_symbol,
                network: this.data.network
            });

            let res = await this.$store.dispatch("vaults/checkAllowance", {
                contractAddress: this.data.contract_address,
                token: token
            });

            if (+res > 0) {
                this.approved = true;
            } else {
                this.checkingApproval = false;
            }
        },
        async approve() {
            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.data.real_token_symbol &&
                    item.network == this.data.network
            );
            //
            if (token == undefined) return;

            this.checkingApproval = true;

            let res;
            let payload = {
                vault_contract: this.data.contract_address,
                token: token
            };

            try {
                if(this.walletProvider == "walletconnect") {
                    this.$store.dispatch("vaults/approve", payload)
                    .then((response) => {
                        console.log("Confirmed Block Number: ", response);
                        if (response) {
                            this.$nextTick(() => {
                                this.approved = true;
                                this.hasToken = true;
                                this.checkingApproval = false;
                            });
                        }
                    })
                    .catch((error) => {
                        Vue.default.toasted.error(error.message, { duration: 3000});
                        this.checkingApproval = false;
                    });
                    return;
                } else {
                    res = await this.$store.dispatch("vaults/approve", payload);
                }
            } catch (error) {
                // if user using brave wallet & reject the request
                if ((navigator.brave && await navigator.brave.isBrave() || false) && error.code === -32602 && error.message == "User rejected the transaction") {
                    Vue.default.toasted.error("User rejected the request");
                    this.checkingApproval = false
                    return;
                }

                if (error.code && error.code === -32602) {
                    // send request in non EIP-1559 format
                    payload.type = "0x0";
                    res = await this.$store.dispatch("vaults/approve", payload);
                }
            }

            if (!res) {
                this.checkingApproval = false;
                return;
            }

            if (res.status) {
                this.$nextTick(() => {
                    this.approved = true;
                    this.hasToken = true;
                    this.checkingApproval = false;
                });
            }
        },
        async maxDeposit() {
            this.depositInput = this.wallet.balance;
        },
        getMaxWithdrawal() {
            this.withdrawlInput = this.calcMaxWithdrawal;
        },
        async checkToken() {
            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.data.token &&
                    item.network == this.data.network
            );
            //
            if (token == undefined) return;
            let res = await this.$store.dispatch("wallet/checkToken", {
                vault_contract: this.data.contract_address,
                token: token
            });

            if (+res > 0) {
            } else {
                this.checkingToken = false;
            }
        },
        async checkEpochWithdraw() {
            // disable withdraw button, max withdraw amount button if there is a ongoing deposit
            if (
                (+this.data.epoch >= this.userInfo.queuedEpoch ||
                    +this.data.queuedDeposits > 0 ||
                    +this.data.myPosition > 0) &&
                this.pQueuedDeposits == 0
            ) {
                this.ableToInitWithdraw = true;
            } else {
                this.ableToInitWithdraw = false;
            }
        },
        // async getPrimiumRealized(){

        //     this.premiumLoad = false;
        //     // if (typeof window.ethereum === "undefined") {
        //     //     this.assetScaleX1e36 = 0;
        //     //     this.userScaleX1e36 = 0;
        //     //     this.activeDeposit = 0;
        //     //     return;
        //     // }

        //     //
        //     // let res = await this.$store.dispatch('vaults/getPrimiumRealized', {
        //     //     vault_contract: this.data.contract_address,
        //     //     epoch: +this.data.vault_detail.epoch,
        //     //     abiType: this.data.type
        //     // });

        //     //

        //     this.assetScaleX1e36 = +res.assetScaleX1e36/1e36;
        //     this.userScaleX1e36 = +res.userScaleX1e36/1e36;
        //     this.activeDeposit = +res.activeDeposit/1e18;

        //     this.premiumLoad = true;

        // }
        async isVaultAtMaxCap() {
            let token = this.wallet.tokens.find(
                item => item.symbol == this.data.token
            );
            if (token == undefined) return true;

            const currBalance = await this.$store.dispatch(
                "vaults/getVaultCurrentDeposit",
                {
                    vault_contract: this.data.contract_address,
                    token: token,
                    vault: this.data
                }
            );

            const decimals = token.decimals;
            if (currBalance / decimals >= this.data.max_deposit) {
                return true;
            }

            return false;
        }
    },
    props: {
        data: {
            type: Object
            // default: () => {
            //     return JSON.parse(localStorage.getItem("vault-data") || "[]");
            // }
        },
        pQueuedDeposits: {
            default: null
        },
        pQueuedWithdraws: {
            default: null
        },
        tab: {
            default: null
        },
        userInfo: {
            type: Object,
            default: {}
        }
    },
    async mounted() {
        // console.log('userinfo',this.userInfo);
        //this.pQueuedDeposits = this.data.queuedDeposits;
        if (this.tab == null) this.tabState = "DEPOSIT";
        //
        if (!this.walletProvider) {
            this.checkingApproval = false;
        } else {
            this.assetScaleX1e36 = this.data.assetScaleX1e36;
            this.userScaleX1e36 = this.userInfo.userScaleX1e36;
            this.activeDeposit = this.userInfo.position;

            this.premiumLoad = true;

            this.checkAllowance();
            //await this.getPrimiumRealized();
            this.checkEpochWithdraw();
            //this.$emit("update-vault");

            this.updateInterval = setInterval(() => {
                this.$emit("update-vault");
            }, 30000);

            // const provider = new ethers.providers.Web3Provider(window.ethereum)
            //
            // const signer = provider.getSigner()
            //
            // let balance = await provider.getBalance("ethers.eth")
            //
            //this.checkToken();
            //localStorage.setItem("vault-data", JSON.stringify(this.data));

            // disable deposit if vault is at max capacity
            this.vaultAtMaxBalance = await this.isVaultAtMaxCap();
        }
    },
    beforeDestroy() {
        clearInterval(this.updateInterval);
        this.updateInterval = null;
        //localStorage.removeItem(tabState);
    }
};
</script>

<style lang="scss">
@import "./resources/sass/_variables.scss";

.wrap-input-placeholder {
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    color: rgba(255, 255, 255, 0.5);
}
.wrap-form-input {
    padding-left: 50px !important;

    @media only screen and (min-width: 1440px) {
        padding-left: 3.4722222222222223vw !important;
    }
}

.max-button-style {
    font-size: 12px;
    line-height: 18px;
    padding: 6px 12px;
    border-top: none;
    border-right: none;
    border-bottom: none;
    border-left: 1px solid rgba(255, 255, 255, 0.5);
    border-image: initial;
    font-style: normal;
    font-weight: 600;
    -webkit-text-fill-color: transparent;

    @media only screen and (min-width: 768px) {
        font-size: 0.97222vw;
        line-height: 1.3vw;
        padding: 0.5vw 1vw;
    }
}

.right-text-mobile {
    text-align: right !important;

    @media only screen and (min-width: 768px) {
        text-align: left !important;
    }
}

.mobile-hidden {
    display: none;

    @media only screen and (min-width: 768px) {
        display: block;
    }
}
a.disabled.text-green-gradient {
    pointer-events: none;
    cursor: default;
    color: #585858 !important;
    background: #585858;
    -webkit-background-clip: text;
}

.btn.btn-primary:disabled {
    color: #585858 !important;
}

.tooltip-icon {
    width: 0.95vw;
    height: 0.95vw;
    margin: auto;
    padding-bottom: 0.1vw;

    @media screen and (min-width: 0px) and (max-width: 768px) {
        width: 13px;
        height: 13px;
    }
}

.cont-vaul-strip {
    position: relative;
    z-index: 1;
    .strip-name-1 {
        width: 100%;
        padding: 9% 0;
    }
    .row {
        margin-right: -1.04167vw;
        margin-left: -1.04167vw;
    }
    .wdh-card {
        min-height: 21.445vw;
        width: 77.084vw;
        display: flow-root;

        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
        ) !important;
        mix-blend-mode: lighten;
        box-shadow: inset 2px 2px 8px rgba(0, 0, 0, 0.5) !important;
        filter: drop-shadow(1px 1px 4px rgba(255, 255, 255, 0.25));
        -webkit-filter: drop-shadow(1px 1px 4px rgba(255, 255, 255, 0.25));
        border-radius: 10px !important;
    }
    label {
        margin-bottom: 0.5555556vw;
    }
    //.acorn-card {
    .green-card {
        /* border: 1px solid var($primary-1) !important; */
        border: 1px solid $primary-1 !important;
        //box-shadow: 1px 3px 15px 1px rgba(110, 226, 159, 0.15) !important;
        .head-strip {
            background: #000000;
            border: 1px solid $primary-1;
            color: $primary-1;
        }
        .percentage,
        .percentage-description {
            color: $accent-1;
        }
    }
    //.walnut-card {
    .orange-card {
        border: 1px solid $primary-3 !important;
        .head-strip {
            background: #000000;
            border: 1px solid $primary-3;
            color: $primary-3;
        }
        .percentage,
        .percentage-description {
            /* color: var($accent-3); */
            color: $accent-3;
        }
    }

    .light-orange-card {
        border: 1px solid $light-orange !important;
        .head-strip {
            background: #000000;
            border: 1px solid $light-orange;
            color: $light-orange;
        }
        .percentage,
        .percentage-description {
            /* color: var($accent-3); */
            color: #ffad4c;
        }
    }
    //.almond-card {
    .blue-card {
        border: 1px solid $primary-2 !important;
        .head-strip {
            background: #000000;
            border: 1px solid $primary-2;
            color: $primary-2;
        }
        .percentage,
        .percentage-description {
            color: $accent-2;
        }
    }

    .light-blue-card {
        border: 1px solid $light-blue !important;
        .head-strip {
            background: #000000;
            border: 1px solid $light-blue;
            color: $light-blue;
        }
        .percentage,
        .percentage-description {
            color: #99d4ff;
        }
    }

    .light-purple-card {
        border: 1px solid $light-purple !important;
        .head-strip {
            background: #000000;
            border: 1px solid $light-purple;
            color: $light-purple;
        }
        .percentage,
        .percentage-description {
            color: #d060f7;
        }
    }

    .light-pink-card {
        border: 1px solid $light-pink !important;
        .head-strip {
            background: #000000;
            border: 1px solid $light-pink;
            color: $light-pink;
        }
        .percentage,
        .percentage-description {
            color: $light-pink;
        }
    }

    .light-lime-card {
        border: 1px solid $light-lime !important;
        .head-strip {
            background: #000000;
            border: 1px solid $light-lime;
            color: $light-lime;
        }
        .percentage,
        .percentage-description {
            color: $light-lime;
        }
    }

    .light-yellow-card {
        border: 1px solid $light-yellow !important;
        .head-strip {
            background: #000000;
            border: 1px solid $light-yellow;
            color: $light-yellow;
        }
        .percentage,
        .percentage-description {
            color: $light-yellow;
        }
    }

    .light-purple-2-card {
        border: 1px solid $light-purple-2 !important;
        .head-strip {
            background: #000000;
            border: 1px solid $light-purple-2;
            color: $light-purple-2;
        }
        .percentage,
        .percentage-description {
            color: $light-purple-2;
        }
    }


    .red-card {
        border: 1px solid $primary-6 !important;
        .head-strip {
            background: #000000;
            border: 1px solid $primary-6;
            color: $primary-6;
        }
        .percentage,
        .percentage-description {
            color: $accent-4;
        }
    }
    .head-strip {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        top: 0%;
        font-family: "Bungee Inline";
        padding: 0.903%;
        font-weight: normal;
        font-size: 0.83333vw;
        line-height: 0.75vw;
        text-align: center;
        box-sizing: border-box;
        border-radius: 0.2777777vw;
    }
    .vault-strip {
        padding: 0;
        display: flex;

        @media only screen and (min-width: 1024px) {
            padding-left: 0;
            padding-right: 0;
        }

        .btn-vault-strip {
            width: 10.5vw;
            height: 2.778vw;
        }
        .text-lg-1 {
            font-size: 1.38889vw !important;
            line-height: calc(1.66667vw + 3px) !important;
        }
        .text-lg-2 {
            font-size: 0.97222vw !important;
            line-height: calc(0.97222vw + 4px) !important;
        }
        .block {
            /* padding: 0 1.04167vw; // 15px on 1440px screen  */
            padding: 0 1.3888888888888888vw; // 20px on 1440px screen
            &.b-left {
                border-left: 1px solid rgba(255, 255, 255, 0.5);
            }
            &.b-right {
                border-left: 1px solid rgba(255, 255, 255, 0.5);
            }
        }
        .icon {
            //margin-left: 20px;
            margin-right: 1.38889vw;
            text-align: center;
            display: flex;
            align-items: center;
            img {
                width: 8.334vw;
                height: 8.334vw;

                // @media only screen and (max-width: 1200px) {
                //     width: 70px;
                //     height: 70px;
                // }
            }
        }
        .head-block {
            /* margin: auto; */

            .caption {
                font-family: "Bungee";
                font-style: normal;
                font-weight: normal;
                font-size: 1.11111vw;
                line-height: calc(1.11111vw + 3px);
                letter-spacing: 0.04em;
                text-transform: uppercase;
                margin-bottom: 0.347222vw;
            }
            .caption-bigger {
                font-family: "Bungee";
                font-style: normal;
                font-weight: normal;
                font-size: 1.66667vw;
                line-height: calc(1.66667vw + 5px);
                letter-spacing: 0.04em;
                text-transform: uppercase;
                margin-bottom: 0.347222vw;
            }
        }
        .percentage {
            margin-top: 0.694445vw;
            margin-bottom: 0.694445vw;
            font-family: "Bungee";
            font-style: normal;
            font-weight: normal;
            font-size: 26px;
            line-height: 2.5vw;
            letter-spacing: 0.04em;

            // @media only screen and (min-width: 768px) {
            //     font-size: calc(16px + 0.3vw);
            // }

            @media only screen and (min-width: 992px) {
                font-size: 3.3333333333333335vw; // 48px;
            }
        }
        .percentage-description {
            font-family: "Exo";
            font-style: normal;
            font-weight: 600;
            font-size: 0.83333vw;
            line-height: calc(0.83333vw + 3px);
            text-transform: uppercase;

            // @media only screen and (min-width: 768px) {
            //     font-size: calc(10px + 0.3vw);
            // }

            @media only screen and (min-width: 992px) {
                font-size: 0.83333vw;
            }

            @media only screen and (min-width: 1440px) {
                font-size: 0.83333vw;
            }
        }
        .tab {
            display: flex;
            .tab-item {
                cursor: pointer;
                width: 50%;
                font-weight: normal;
                font-size: 0.97222vw; //14px;
                //font-size: $text-normal;
                line-height: 0.97222vw;
                text-align: center;
                letter-spacing: 0.05em;
                text-transform: uppercase;
                color: #9c9c9c;
                &.active {
                    font-weight: bold;
                    color: #fff;
                }
            }
        }
        .input-group-outline {
            height: 2.848vw;
            border: 1px solid rgba(255, 255, 255, 0.5);
            background: transparent;
            border-radius: 20px;
            padding: 0.2vw 0.347222vw;
            font-style: normal;
            font-weight: 600;
            // font-size: 14px;
            font-size: 0.97222vw; //$text-normal;
            line-height: 0.97222vw; //14px;
            .form-control {
                background: transparent;
                border: none;
                color: #fff;
                &::placeholder {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */
                    color: #9c9c9c;
                    opacity: 1; /* Firefox */
                }

                &:-ms-input-placeholder {
                    /* Internet Explorer 10-11 */
                    color: #9c9c9c;
                }

                &::-ms-input-placeholder {
                    /* Microsoft Edge */
                    color: #9c9c9c;
                }
            }
            .input-group-text {
                font-family: Exo !important;
                background: transparent;
                border: none;
                border-left: 1px solid rgba(255, 255, 255, 0.5);
                font-style: normal;
                font-weight: 600;
                font-size: 0.97222vw; //14px;
                //font-size: $text-normal;
                line-height: 0.97222vw; //14px;
                background: $gradient-1;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                padding: 0.416667vw 0.83333vw;
            }
        }
        .blok-1 {
            display: flex;
            align-items: center;
            flex: 0 0 37%;
            max-width: 37%;
            /* padding-right: 3rem; */
            /* padding-left: 0;
            padding-right: 0; */
            min-height: 16.528vw;
        }
        .blok-2 {
            display: flex;
            flex: 0 0 25%;
            max-width: 25%;
            //padding-top: 1.7vw;
            min-height: 16.528vw;
        }
        .blok-3 {
            flex: 0 0 38%;
            max-width: 38%;
            min-height: 16.528vw;
        }
    }
    .col,
    .col-1,
    .col-10,
    .col-11,
    .col-12,
    .col-2,
    .col-3,
    .col-4,
    .col-5,
    .col-6,
    .col-7,
    .col-8,
    .col-9,
    .col-auto,
    .col-lg,
    .col-lg-1,
    .col-lg-10,
    .col-lg-11,
    .col-lg-12,
    .col-lg-2,
    .col-lg-3,
    .col-lg-4,
    .col-lg-5,
    .col-lg-6,
    .col-lg-7,
    .col-lg-8,
    .col-lg-9,
    .col-lg-auto,
    .col-md,
    .col-md-1,
    .col-md-10,
    .col-md-11,
    .col-md-12,
    .col-md-2,
    .col-md-3,
    .col-md-4,
    .col-md-5,
    .col-md-6,
    .col-md-7,
    .col-md-8,
    .col-md-9,
    .col-md-auto,
    .col-sm,
    .col-sm-1,
    .col-sm-10,
    .col-sm-11,
    .col-sm-12,
    .col-sm-2,
    .col-sm-3,
    .col-sm-4,
    .col-sm-5,
    .col-sm-6,
    .col-sm-7,
    .col-sm-8,
    .col-sm-9,
    .col-sm-auto,
    .col-xl,
    .col-xl-1,
    .col-xl-10,
    .col-xl-11,
    .col-xl-12,
    .col-xl-2,
    .col-xl-3,
    .col-xl-4,
    .col-xl-5,
    .col-xl-6,
    .col-xl-7,
    .col-xl-8,
    .col-xl-9,
    .col-xl-auto {
        padding-right: 1.04167vw;
        padding-left: 1.04167vw;
        @media screen and (min-width: 0px) and (max-width: 768px) {
            padding-right: 15px;
            padding-left: 15px;
        }
    }
}
@media screen and (min-width: 0px) and (max-width: 768px) {
    .cont-vaul-strip {
        .btn-vault-strip {
            width: 150.5px !important;
            height: 40px !important;
            font-size: 14px !important;
            line-height: 12px !important;
        }
        .strip-name-1 {
            padding: 10px 0 1px;
        }
        .wdh-card {
            height: auto;
            width: auto;
        }
        .row {
            margin-right: -15px;
            margin-left: -15px;
        }
        .head-strip {
            padding: 8px 12px;
            font-size: 12px;
            line-height: 10px;
            border-radius: 4px;
        }
        .tab {
            .tab-item {
                font-size: 14px !important;
                line-height: 14px !important;
            }
        }
        .vault-strip {
            padding: 0 10px;
            .input-group-outline {
                height: 41px;
                padding: 3px 3px;
                font-size: 14px;
                line-height: 14px;
                .input-group-text {
                    font-size: 14px;
                    line-height: 14px;
                    padding: 5px 20px;
                }
            }
            .icon {
                img {
                    width: 39px;
                    height: 39px;
                }
            }
            .text-lg-1 {
                font-size: 16px !important;
                line-height: 21px !important;
            }
            .text-lg-2 {
                font-size: 16px !important;
                line-height: 21px !important;
            }
            .blok-1 {
                flex: 0 0 100%;
                max-width: 100%;
                padding-top: 15px;
                padding-bottom: 15px;
                height: auto;
            }
            .blok-2 {
                flex: 0 0 100%;
                max-width: 100%;
                padding-top: 15px !important;
                height: auto;
            }
            .blok-3 {
                flex: 0 0 100%;
                max-width: 100%;
                padding-top: 15px;
                height: auto;
            }
            .mob-space {
                margin-bottom: 20px;
            }
            .block {
                &.b-left {
                    border-left: none;
                }
                &.b-right {
                    border-left: none;
                }
            }
            .mob-balance {
                position: absolute;
                left: 50%;
            }
            .head-block {
                margin: auto;
                /* padding-right: 0;
                padding-left: 0; */
                padding: 0 5px;

                .caption {
                    font-size: 12px;
                    line-height: 12px;
                    margin-bottom: 5px;
                }
                .caption-bigger {
                    font-size: 16px;
                    line-height: 16px;
                    margin-bottom: 5px;
                }
            }
            .percentage {
                font-size: 26px;
                line-height: 31px;
                /* text-align: center; */
                margin-bottom: 5px;
            }
            .percentage-description {
                font-size: 8px;
                line-height: 11px;
                /* text-align: center; */
                margin-bottom: 5px;
            }
        }
        //.acorn-card {
        .green-card {
            .block {
                &.b-left {
                    border-top: 0.3px solid $primary-1;
                }
                &.b-right {
                    border-top: 0.3px solid $primary-1;
                }
            }
        }
        //.almond-card {
        .orange-card {
            .block {
                &.b-left {
                    border-top: 0.3px solid $primary-2;
                }
                &.b-right {
                    border-top: 0.3px solid $primary-2;
                }
            }
        }
        //.walnut-card {
        .blue-card {
            .block {
                &.b-left {
                    border-top: 0.3px solid $primary-3;
                }
                &.b-right {
                    border-top: 0.3px solid $primary-3;
                }
            }
        }

        .red-card {
            .block {
                &.b-left {
                    border-top: 0.3px solid $primary-6;
                }
                &.b-right {
                    border-top: 0.3px solid $primary-6;
                }
            }
        }
    }
}

.vault-strip .blok-3 div.row:not(:last-child) div.col-6,
.vault-strip .blok-3 div.row:not(:last-child) div.col-12 {
    padding: 0;
}

.vault-strip .blok-3 div.row:not(:last-child) div.col-8,
.vault-strip .blok-3 div.row:not(:last-child) div.col-9 {
    padding: 0;
}

.vault-strip .blok-3 div.row:not(:last-child) div.col-4,
.vault-strip .blok-3 div.row:not(:last-child) div.col-3 {
    padding: 0;
}

.tooltip-selector {
    color: rgba(110, 226, 159, 1);
    position: relative;

    &:hover .tooltip-container {
        display: block;
    }

    .tooltip-container {
        display: none;
        position: absolute;
        bottom: 20%;
        left: 105%;
        color: white;
        width: 40.866667vw;
        background: rgba(29, 29, 29, 0.7);
        border-radius: 10px;
        border: 1px solid rgba(39, 174, 96, 0.5);
        z-index: 10;

        .tooltip-bg-blur {
            backdrop-filter: blur(20px);
            padding: 20px;

            @media only screen and (min-width: 1440px) {
                backdrop-filter: blur(1.3888888888888888vw);
                padding: 1.3888888888888888vw;
            }
        }

        @media only screen and (max-width: 1440px) {
            max-width: 242.5px;
        }

        @media only screen and (min-width: 1440px) {
            width: 16.84027777777778vw;
            border-radius: 0.6944444444444444vw;
        }

        ul {
            text-transform: none;
            margin: 0;
            font-size: 10px;
            line-height: 13.29px;
            padding-left: 15px;

            @media only screen and (min-width: 1440px) {
                font-size: 0.6944444444444444vw;
                line-height: 0.9229166666666667vw;
                padding-left: 1.0416666666666667;
            }
        }
    }
}

.icon-coin-container {
    @media only screen and (min-width: 1440px) {
        img {
            width: 4.444444444444445vw;
            height: 4.513888888888889vw;
        }
    }
}

.btn-withdraw-request {
    @media only screen and (min-width: 1440px) {
        padding: 0px 0.8333333333333334vw !important;
        border-radius: 1.3888888888888888vw !important;
    }
}
</style>
